import type { ReactNode } from 'react'
import { useParams } from 'react-router-dom'
import { productFromSlug, type PageSlug } from '../lib/routes'
import { NotFound } from '../pages/NotFound'

/** The `/{page}/:tab` element of a tabbed page: renders the page for a known
 * product slug (`mambu-mcp`, `mambu-agents`) and the in-page not-found state
 * for anything else — no redirect, the URL stays as typed (MS-818 OQ-5). The
 * page itself reads the tab via `useProductTab`. Same route match across a
 * tab change, so the page element stays mounted. */
export function ProductTabRoute({
  page,
  children,
}: Readonly<{ page: PageSlug; children: ReactNode }>): ReactNode {
  const { tab } = useParams()
  return productFromSlug(tab) ? children : <NotFound page={page} />
}
